import headerImgEn from "assets/images/v111/header-en.webp"
import infoImgEn from "assets/images/v111/info-en.webp"

export const v111ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
